import { StackScreenProps } from "@react-navigation/stack";
import { EditProductRootParamList } from "../../../../types";
import { useTranslation } from "../../../../utilities/i18n";
import {
  Card,
  FlatActionList,
  Page,
  View,
} from "@towersystems/roam-common-native";
import { useSelectedProductEntityContextProvider } from "../../utils";

export type ProductViewInventoryLevelsScreenProps = StackScreenProps<
  EditProductRootParamList,
  "ProductViewInventoryLevelsScreen"
>;

export const ProductViewInventoryLevelsScreen =
  ({}: ProductViewInventoryLevelsScreenProps) => {
    const { t } = useTranslation("product");
    const { product } = useSelectedProductEntityContextProvider();
    return (
      <Page
        title={t("view_inventory_title")}
        secondaryTitle={t("view_inventory_subtitle")}
      >
        <Card>
          <FlatActionList
            items={product.locationInventoryPricing.map((i) => ({
              key: i.id,
              title: i.location?.name ?? t("common:unkown_location"),
              subTitle: `${i.stockOnHand} in stock`,
              componentRight: () => {
                return <View />;
              },
            }))}
          />
        </Card>
      </Page>
    );
  };
